(() => {
  'use strict';
  if (window.pnmProductShippingReady) return;
  window.pnmProductShippingReady = true;

  // Compare the cutoff in the warehouse time zone, then advance calendar dates.
  // This avoids adding 24-hour intervals across daylight-saving transitions.
  function dispatchDate(now, timeZone, cutoffHour) {
    const values = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone, year:'numeric', month:'numeric', day:'numeric', hour:'numeric', hourCycle:'h23'
    }).formatToParts(now).map(part => [part.type, part.value]));
    const day = new Date(Date.UTC(Number(values.year), Number(values.month)-1, Number(values.day)));
    day.setUTCDate(day.getUTCDate() + (Number(values.hour) >= cutoffHour ? 2 : 1));
    while (day.getUTCDay() === 0 || day.getUTCDay() === 6) day.setUTCDate(day.getUTCDate()+1);
    return day;
  }
  function canDispatch(variant, quantity) {
    const count = Number(quantity);
    return Boolean(variant?.available && variant.tracked && Number.isInteger(count) && count > 0 && count <= Number(variant.quantity));
  }
  let countryRequest;
  function countryFromDetection(data) {
    const handle = data?.detected_values?.country?.handle;
    return typeof handle === 'string' && /^[a-z]{2}$/i.test(handle) ? handle.toUpperCase() : '';
  }
  function geolocateCountry() {
    if (countryRequest) return countryRequest;
    countryRequest = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 4000);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const url = new URL(root + 'browsing_context_suggestions.json', location.origin);
        if (url.origin !== location.origin) return '';
        url.searchParams.set('country[enabled]', 'true');
        const response = await fetch(url.href, {
          credentials:'same-origin', cache:'no-store',
          headers:{Accept:'application/json'}, signal:controller.signal
        });
        if (!response.ok) return '';
        return countryFromDetection(await response.json());
      } catch (_) { return ''; }
      finally { clearTimeout(timeout); }
    })();
    return countryRequest;
  }
  function initialize() {
    document.querySelectorAll('[data-pnm-product-shipping]').forEach(panel => {
      if (panel.dataset.initialized) return;
      const configNode = panel.querySelector('[data-pnm-shipping-config]');
      const product = panel.closest('[data-pnm-product]');
      const form = product?.querySelector('form[data-product-form]');
      if (!configNode || !form) return;
      panel.dataset.initialized = 'true';
      const config = JSON.parse(configNode.textContent);
      const title = panel.querySelector('[data-pnm-shipping-title]');
      const flag = panel.querySelector('[data-pnm-shipping-flag]');
      const free = panel.querySelector('[data-pnm-shipping-free]');
      const prefix = panel.querySelector('[data-pnm-shipping-date-label]');
      const date = panel.querySelector('[data-pnm-shipping-date]');
      let timer = 0, frame = 0, countryKey = null, dateKey = '', detectedCountry = '';
      function update() {
        frame = 0; clearTimeout(timer);
        if (!panel.isConnected) { stockObserver?.disconnect(); return; }
        const variantInput = form.querySelector('[name="id"]');
        const id = variantInput ? variantInput.value : config.initialVariant;
        const variant = config.variants.find(item => String(item.id) === String(id));
        const quantityInput = form.querySelector('[name="quantity"]');
        const quantity = quantityInput ? quantityInput.value : '1';
        panel.hidden = !canDispatch(variant, quantity);
        const country = detectedCountry;
        if (country !== countryKey) {
          countryKey = country;
          title.textContent = country === 'CA' ? config.canada : country === 'US' ? config.usa : config.other;
          if (free) free.textContent = country === 'CA' ? config.freeCanada : country === 'US' ? config.freeUsa : config.freeOther;
          flag.hidden = country !== 'CA' && country !== 'US';
          if (!flag.hidden) flag.src = 'https://cdn.shopify.com/static/images/flags/' + country.toLowerCase() + '.svg?width=32';
          panel.dataset.country = country;
        }
        const now = new Date();
        const shipping = dispatchDate(now, config.timeZone, config.cutoffHour);
        const iso = shipping.toISOString().slice(0,10);
        const locale = document.documentElement.lang || config.locale || 'en';
        const key = iso + '|' + locale;
        if (dateKey !== key) {
          dateKey = key;
          let formatter;
          try { formatter = new Intl.DateTimeFormat(locale,{weekday:'long',month:'short',day:'numeric',timeZone:'UTC'}); }
          catch (_) { formatter = new Intl.DateTimeFormat('en',{weekday:'long',month:'short',day:'numeric',timeZone:'UTC'}); }
          prefix.textContent = config.shipsBy;
          date.dateTime = iso; date.textContent = formatter.format(shipping); date.hidden = false;
        }
        // Refresh precisely at minute boundaries, including 11 p.m. and midnight.
        timer = setTimeout(update, 60000 - (now.getSeconds()*1000 + now.getMilliseconds()) + 50);
      }
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      form.addEventListener('change',schedule); form.addEventListener('input',schedule); form.addEventListener('click',schedule);
      const add = form.querySelector('[data-add-to-cart]');
      const stockObserver = add ? new MutationObserver(schedule) : null;
      stockObserver?.observe(add,{attributes:true,attributeFilter:['disabled','class'],childList:true,subtree:true});
      window.addEventListener('pageshow',schedule); window.addEventListener('popstate',schedule);
      document.addEventListener('visibilitychange',() => { if (!document.hidden) schedule(); });
      update();
      geolocateCountry().then(country => {
        detectedCountry = country;
        if (panel.isConnected) schedule();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true}); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
